import { API, graphqlOperation, input } from 'aws-amplify';
import {
  createcompanydetails,
  CreatecompanydetailsMutation,
  CreatecompanydetailsMutationVariables,
  createcompanyentity,
  CreatecompanyentityMutation,
  CreatecompanyentityMutationVariables,
  createFinancialYear,
  CreateFinancialYearMutation,
  CreateFinancialYearMutationVariables,
  createNumberTracker,
  CreateNumberTrackerMutation,
  CreateNumberTrackerMutationVariables,
  createPartyAddressEntity,
  CreatePartyAddressEntityInput,
  CreatePartyAddressEntityMutation,
  CreatePartyAddressEntityMutationVariables,
  createtransferfinancialyeardata,
  CreatetransferfinancialyeardataMutation,
  CreatetransferfinancialyeardataMutationVariables,
  getCompany,
  GetCompanyQuery,
  transferAccountsToFinancialYear,
  TransferAccountsToFinancialYearMutation,
  TransferAccountsToFinancialYearMutationVariables,
  updatefinancialyearsteps,
  UpdatefinancialyearstepsMutation,
  UpdatefinancialyearstepsMutationVariables,
} from '../../../graphql';

export const CreateFinancialYearAndTransferData = async (
  input: CreatetransferfinancialyeardataMutationVariables
): Promise<NonNullable<CreatetransferfinancialyeardataMutation>['createtransferfinancialyeardata']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(createtransferfinancialyeardata, input))) as {
      data: CreatetransferfinancialyeardataMutation;
    };
    if (data?.createtransferfinancialyeardata?.statuscode === 'Error') {
      throw new Error(data.createtransferfinancialyeardata.statusmessage || 'Error in CreateFinancialYearAndTransferData');
    }
    return data?.createtransferfinancialyeardata;
  } catch (error) {
    throw error;
  }
};

export const CreateFinancialYear = async (
  input: CreateFinancialYearMutationVariables
): Promise<NonNullable<CreateFinancialYearMutation>['createFinancialYear']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(createFinancialYear, input))) as { data: CreateFinancialYearMutation };

    return data.createFinancialYear;
  } catch (error) {
    throw error;
  }
};

export const TransferAccountsQuery = async (
  input: TransferAccountsToFinancialYearMutationVariables
): Promise<NonNullable<TransferAccountsToFinancialYearMutation['transferAccountsToFinancialYear']>> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(transferAccountsToFinancialYear, input))) as {
      data: TransferAccountsToFinancialYearMutation;
    };

    if (!data?.transferAccountsToFinancialYear) {
      throw new Error('transferAccountsToFinancialYear returned null or undefined');
    }

    return data.transferAccountsToFinancialYear;
  } catch (error) {
    throw error;
  }
};

export const getCompanyData = async (): Promise<NonNullable<GetCompanyQuery['getCompany']>[0]> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(getCompany))) as { data: GetCompanyQuery };
    if (!data?.getCompany) {
      throw new Error('getCompany returned null or undefined');
    }
    return data.getCompany[0];
  } catch (error) {
    throw error;
  }
};

export const CreateCompanyDetailsMutation = async (
  input: CreatecompanydetailsMutationVariables
): Promise<NonNullable<CreatecompanydetailsMutation>['createcompanydetails']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(createcompanydetails, input))) as { data: CreatecompanydetailsMutation };

    if (!data?.createcompanydetails) {
      throw new Error('createcompanydetails returned null or undefined');
    }

    return data.createcompanydetails;
  } catch (error) {
    throw error;
  }
};

export const createCompanyEntityMutation = async (
  input: CreatecompanyentityMutationVariables
): Promise<NonNullable<CreatecompanyentityMutation>['createcompanyentity']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(createcompanyentity, input))) as { data: CreatecompanyentityMutation };

    if (!data?.createcompanyentity) {
      throw new Error('createcompanyentity returned null or undefined');
    }

    return data.createcompanyentity;
  } catch (error) {
    throw error;
  }
};

export const CompanyPartyAddressEntity = async (
  input: CreatePartyAddressEntityMutationVariables
): Promise<NonNullable<CreatePartyAddressEntityMutation>['createPartyAddressEntity']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(createPartyAddressEntity, input))) as { data: CreatePartyAddressEntityMutation };
    if (!data?.createPartyAddressEntity) {
      throw new Error('createPartyAddressEntity returned null or undefined');
    }
    return data.createPartyAddressEntity;
  } catch (error) {
    throw error;
  }
};

export const CreateNumberTrackerMutationFN = async (
  input: CreateNumberTrackerMutationVariables
): Promise<NonNullable<CreateNumberTrackerMutation>['createNumberTracker']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(createNumberTracker, input))) as { data: CreateNumberTrackerMutation };

    if (!data?.createNumberTracker) {
      throw new Error('createNumberTracker returned null or undefined');
    }
    return data.createNumberTracker;
  } catch (error) {
    throw error;
  }
};

export const UpdateFinancialYearMutation = async (
  input: UpdatefinancialyearstepsMutationVariables
): Promise<NonNullable<UpdatefinancialyearstepsMutation>['updatefinancialyearsteps']> => {
  try {
    const { data } = (await API.graphql(graphqlOperation(updatefinancialyearsteps, input))) as { data: UpdatefinancialyearstepsMutation };
    if (!data?.updatefinancialyearsteps) {
      throw new Error('updatefinancialyearsteps returned null or undefined');
    }
    return data.updatefinancialyearsteps;
  } catch (error) {
    throw error;
  }
};
